/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc
 */
import * as References from './McpServerRegistryRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServerById
 */
export const GET_MCP_SERVER_BY_ID_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServerById';
export const GET_MCP_SERVER_BY_ID_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServerByIdRequestType,
  References.GetMcpServerByIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVER_BY_ID_QUERY_FIELD_NAME,
  args: ['id'],
  fetcher(
    request: References.GetMcpServerByIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServerByIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServerByIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServers
 */
export const GET_MCP_SERVERS_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServers';
export const GET_MCP_SERVERS_QUERY: RegisteredQuery<
  'result',
  Record<string, unknown>,
  References.GetMcpServersResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_QUERY_FIELD_NAME,
  args: [],
  fetcher(
    _,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getMcpServersRpc, {
      timeout: ctx.timeout,
      request: {},
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersByAuthenticatorId
 */
export const GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersByAuthenticatorId';
export const GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServersByAuthenticatorIdRequestType,
  References.GetMcpServersByAuthenticatorIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_BY_AUTHENTICATOR_ID_QUERY_FIELD_NAME,
  args: ['authenticatorId'],
  fetcher(
    request: References.GetMcpServersByAuthenticatorIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersByAuthenticatorIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServersByAuthenticatorIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServerLogos
 */
export const GET_MCP_SERVER_LOGOS_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServerLogos';
export const GET_MCP_SERVER_LOGOS_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServerLogosRequestType,
  References.GetMcpServerLogosResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVER_LOGOS_QUERY_FIELD_NAME,
  args: ['mcpServerIds'],
  fetcher(
    request: References.GetMcpServerLogosRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServerLogosResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServerLogosRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersAvailableToPortal
 */
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersAvailableToPortal';
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServersAvailableToPortalRequestType,
  References.GetMcpServersAvailableToPortalResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_QUERY_FIELD_NAME,
  args: ['search'],
  fetcher(
    request: References.GetMcpServersAvailableToPortalRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersAvailableToPortalResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServersAvailableToPortalRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersByAppId
 */
export const GET_MCP_SERVERS_BY_APP_ID_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersByAppId';
export const GET_MCP_SERVERS_BY_APP_ID_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServersByAppIdRequestType,
  References.GetMcpServersByAppIdResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_BY_APP_ID_QUERY_FIELD_NAME,
  args: ['appId'],
  fetcher(
    request: References.GetMcpServersByAppIdRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersByAppIdResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServersByAppIdRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.mcp.server.registry.rpc.McpServerRegistryRpc#getMcpServersAvailableToPortalPaginated
 */
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY_FIELD_NAME =
  'com_hubspot_mcp_server_registry_rpc_McpServerRegistryRpc_getMcpServersAvailableToPortalPaginated';
export const GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY: RegisteredQuery<
  'result',
  References.GetMcpServersAvailableToPortalPaginatedRequestType,
  References.GetMcpServersAvailableToPortalPaginatedResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_MCP_SERVERS_AVAILABLE_TO_PORTAL_PAGINATED_QUERY_FIELD_NAME,
  args: ['search', 'after', 'offset', 'limit', 'sortBy', 'sortDirection'],
  fetcher(
    request: References.GetMcpServersAvailableToPortalPaginatedRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetMcpServersAvailableToPortalPaginatedResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getMcpServersAvailableToPortalPaginatedRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
